<template>
  <div>
    <div
      class="produto-clube-vantagens-formulario"
      v-show="produto == 'anuncio'"
    >
      <div v-show="formulario == 'cadastro'">
        <FormulateForm
          name="Anuncio"
          v-model="values"
          @submit="salvar('formulario')"
        >
          <div class="mt-1 form-wrap px-4 pb-4">
            <div class="row">
              <div class="col-md-12 mt-4">
                <FormulateInput
                  type="text"
                  name="titulo"
                  label="Título (Identificação do Anúncio)"
                  placeholder="Ex: Casa da Moda"
                  validation="required"
                />
              </div>
              <div class="col-md-12 mt-4">
                <FormulateInput
                  name="tipoAtividade"
                  :options="{
                    Comércio: 'Comércio',
                    Serviço: 'Prestação de Serviço',
                  }"
                  type="radio"
                  label="Tipo da Atividade"
                />
              </div>
              <div class="col-md-12 mt-4">
                <FormulateInput
                  type="textarea"
                  name="descricaoAtividade"
                  label="Descrição da Atividade"
                  validation="required"
                />
              </div>
              <div class="col-md-12 mt-4">
                <FormulateInput
                  type="textarea"
                  name="siteMidiasSociais"
                  label="Site e mídias sociais"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mt-4">
                <FormulateInput
                  name="descontoOferecido"
                  type="text"
                  label="Desconto Oferecido para os usuários (Ex: 10%, 15%)"
                  validation="required"
                />
              </div>
              <div class="col-md-6 mt-4">
                <FormulateInput
                  type="textarea"
                  name="descricaoDesconto"
                  label="Descrição do Desconto / Benefício oferecido"
                  validation="required"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <FormulateInput
                  name="possuiECommerce"
                  :options="{
                    Sim: 'Sim',
                    Não: 'Não',
                  }"
                  type="radio"
                  label="A sua loja possui e-commerce?"
                />
              </div>
              <div class="col-md-5 mt-4" v-if="values.possuiECommerce == 'Sim'">
                <FormulateInput
                  type="text"
                  name="cupomDesconto"
                  label="Deseja fornecer um cupom de desconto? Informe aqui o cupom:"
                />
              </div>
              <div class="col-md-4 mt-4" v-if="values.possuiECommerce == 'Sim'">
                <FormulateInput
                  name="enderecoECommerce"
                  type="text"
                  label="Endereço do E-commerce"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <FormulateInput
                  name="enquadramento"
                  :options="{
                    'Bem estar e beleza': 'Bem estar e beleza',
                    Alimentação: 'Alimentação',
                    Compras: 'Compras',
                    Educação: 'Educação',
                    Entretenimento: 'Entretenimento',
                    'Esportes e academia': 'Esportes e academia',
                    'Infanto juvenil': 'Infanto juvenil',
                    Saúde: 'Saúde',
                    Serviços: 'Serviços',
                    'Viagens e turismo': 'Viagens e turismo',
                    Outros: 'Outros',
                  }"
                  type="checkbox"
                  label="Seu produto / serviço se enquadra em qual das descrições abaixo?"
                />
              </div>
              <div
                class="col-md-6"
                v-if="
                  values.enquadramento &&
                  values.enquadramento.includes('Outros')
                "
              >
                <FormulateInput
                  type="text"
                  name="Outros"
                  label="Informe seu produto / serviço:"
                />
              </div>
              <div class="col-md-12 mt-4">
                <FormulateInput
                  name="deAcordo"
                  :options="{
                    Sim: 'Sim',
                    Não: 'Não',
                  }"
                  type="radio"
                  label="Você está de acordo com a veiculação da sua marca em canais de comunicação da CDL/BH e em sua mídias sociais?"
                />
              </div>
              <div class="col-md-6 mt-4">
                <FormulateInput
                  name="dtInicio"
                  type="date"
                  label="Data de Início"
                  validation="required"
                />
              </div>
              <div class="col-md-6 mt-4">
                <FormulateInput
                  type="date"
                  name="dtFim"
                  label="Data de Encerramento"
                  validation="required"
                />
              </div>
            </div>
          </div>
          <div class="row mt-5 flex-column-reverse flex-md-row">
            <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
              <Botao
                title="Voltar"
                link="/produto/clube-vantagens/painel"
                nameClass="btn btn-outline-secondary btn-lg btn-block"
                >VOLTAR</Botao
              >
            </div>
            <!--<div class="col-md-4 col-lg-3">
            <Botao
              title="Próximo"
              @click="maisprodutos('usuarios')"
              nameClass="btn btn-lg btn-block font-weight-bold btn-success"
              >SOLICITAR USUÁRIOS</Botao
            >
          </div>-->
            <div class="col-md-4 col-lg-2">
              <Botao
                title="Próximo"
                @click="validar('Anuncio')"
                nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
                >PRÓXIMO</Botao
              >
            </div>
          </div>
        </FormulateForm>
      </div>
      <div class="arquivos-form" v-show="formulario == 'imagens'">
        <FormulateForm
          name="Imagens"
          v-model="valuesImagens"
          @submit="salvar('imagens')"
        >
          <div class="mt-1 form-wrap px-4 pb-4 pt-3">
            <h4 class="mb-3">Envio de imagens</h4>
            <div class="row">
              <FormulateInput
                type="file"
                :name="'logomarca'"
                label="Logomarca (Resolução ideal: 800 x 800 pixels)"
                validation="required|mime:image/jpeg,image/gif,image/png,image/x-eps"
                class="col-md-4"
              />
            </div>
            <div class="row">
              <FormulateInput
                type="file"
                :name="'anuncioPadrao'"
                label="Anúncio (Resolução ideal: 700 x 400 pixels)"
                validation="required|mime:image/jpeg,image/gif,image/png,image/x-eps"
                class="col-md-4"
              />
            </div>
            <div class="row mt-3 arquivos-form">
              <div class="form-check d-flex pl-2 pb-2 align-items-center">
                <input
                  type="checkbox"
                  id="ciente"
                  v-model="aceite"
                  name="ciente"
                /><label for="ciente" class="small ml-1"
                  >Aceito os
                  <a
                    href="https://www.cdlbh.com.br/termo-aditivo-ao-contrato-de-filiacao-e-rateio-de-despesas-produto-clube-de-vantagens-cdl-bh/"
                    target="_blank"
                    >termos de uso e política de vendas</a
                  ></label
                >
              </div>
            </div>
          </div>

          <div class="row mt-5 flex-column-reverse flex-md-row">
            <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
              <Botao
                title="Voltar"
                @click="formulario = 'cadastro'"
                nameClass="btn btn-outline-secondary btn-lg btn-block"
                >VOLTAR</Botao
              >
            </div>
            <div class="col-md-4 col-lg-2">
              <Botao
                title="Enviar"
                :class="{ disabled: loading | !aceite }"
                @click="!loading ? validar('Imagens') : ''"
                nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
                :disabled="{ disabled: !aceite }"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                <span v-if="loading">SALVANDO...</span>
                <span v-else>ENVIAR</span>
              </Botao>
            </div>
          </div>
        </FormulateForm>
      </div>
    </div>
    <div
      class="produto-clube-vantagens-formulario"
      v-show="produto == 'usuarios'"
    >
      <div v-if="envioArquivos">
        <UploadArquivo @click="cancelarEnvio()" />
      </div>
      <div v-else>
        <FormulateForm
          name="Usuario"
          v-model="values"
          @submit="salvar('usuarios')"
        >
          <div v-if="usuarios && usuarios.length > 0">
            <div
              class="mt-1 form-wrap px-4 pb-4 mb-4 pt-4"
              v-for="(value, k) in usuarios"
              :key="k"
            >
              <div class="row flex-md-row justify-content-between px-3">
                <span class="label">{{ value.name + " " + (k + 1) }}</span>
                <a href="#" class="text-danger" @click="remover(k)">Remover</a>
              </div>
              <div class="row">
                <div class="col-md-8 mt-2">
                  <FormulateInput
                    :name="'nome_' + k"
                    type="text"
                    label="Nome Completo (opcional)"
                  />
                </div>
                <div class="col-md-4 mt-2">
                  <FormulateInput
                    type="text"
                    :name="'cpf_' + k"
                    label="CPF"
                    validation="required"
                    v-mask="'###.###.###-##'"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-lg-3">
                <b-button
                  class="btn-block"
                  variant="success"
                  @click="addUsuario"
                  >ADICIONAR USUÁRIO</b-button
                >
              </div>
            </div>
            <div class="row mt-5">
              <div
                class="col-md-6 form-check d-flex pl-2 pb-2 align-items-center"
              >
                <input
                  type="checkbox"
                  id="ciente"
                  v-model="aceite"
                  name="ciente"
                /><label for="ciente" class="small ml-1"
                  >Declaro estar ciente e de acordo com as condições previstas
                  no
                  <a
                    href="https://www.cdlbh.com.br/termo-aditivo-ao-contrato-de-filiacao-e-rateio-de-despesas-produto-clube-de-vantagens-cdl-bh/"
                    target="_blank"
                    >Termo de Uso do Clube de Vantagens</a
                  >, me responsabilizando pelas informações fornecidas
                </label>
              </div>
            </div>
            <div class="row mt-5 flex-column-reverse flex-md-row">
              <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
                <Botao
                  title="Voltar"
                  link="/produto/clube-vantagens/painel"
                  nameClass="btn btn-outline-secondary btn-lg btn-block"
                  >VOLTAR</Botao
                >
              </div>
              <!--<div class="col-md-4 col-lg-3">
              <Botao
                title="Próximo"
                @click="maisprodutos('anuncio')"
                nameClass="btn btn-lg btn-block font-weight-bold btn-success"
                >SOLICITAR ANÚNCIO</Botao
              >
            </div>-->
              <div class="col-md-4 col-lg-2">
                <Botao
                  title="Salvar"
                  :class="{ disabled: loading | !aceite }"
                  @click="!loading ? validar('Usuario') : ''"
                  nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
                  :disabled="{ disabled: !aceite }"
                >
                  <span
                    class="spinner-grow spinner-grow-sm pr-2"
                    role="status"
                    aria-hidden="true"
                    v-show="loading"
                  ></span>
                  <span v-if="loading">SALVANDO...</span>
                  <span v-else>SALVAR</span>
                </Botao>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row mt-3">
              <div class="col-md-4 col-lg-3">
                <b-button
                  class="btn-block"
                  variant="success"
                  @click="addUsuario"
                  >ADICIONAR USUÁRIO</b-button
                >
              </div>
              <div class="col-md-1 col-lg-1 text-center pt-3">OU</div>
              <div class="col-md-4 col-lg-3">
                <b-button
                  class="btn-block"
                  variant="success"
                  @click="envioArquivos = true"
                  >ENVIAR PLANILHA DE USUÁRIOS</b-button
                >
              </div>
            </div>
            <div class="row mt-5 flex-column-reverse flex-md-row">
              <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
                <Botao
                  title="Voltar"
                  link="/produto/clube-vantagens/painel"
                  nameClass="btn btn-outline-secondary btn-lg btn-block"
                  >VOLTAR</Botao
                >
              </div>
            </div>
          </div>
        </FormulateForm>
      </div>
    </div>
    <div class="produto-clube-vantagens-formulario" v-if="produto == 'banner'">
      <div class="mt-3">
        <strong
          >OBS. Será permitido somente 01 banner de destaque por vez e deverá
          estar atrelado a um anúncio vigente</strong
        >
      </div>
      <FormulateForm name="Banner" v-model="values" @submit="salvar('banner')">
        <div class="mt-1 form-wrap px-4 pb-4 pt-3">
          <div class="row">
            <div class="col-md-6 mt-4">
              <FormulateInput
                type="text"
                name="titulo"
                label="Título (Identificação do Banner)"
                validation="required"
              />
            </div>
            <div class="col-md-6 mt-4">
              <FormulateInput
                type="select"
                name="anuncioId"
                :options="listaAnunciosBanner"
                label="Vincular Anúncio"
                validation="required"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-4">
              <FormulateInput
                name="dtInicio"
                type="date"
                label="Data de Início"
                validation="required"
              />
            </div>
            <div class="col-md-6 mt-4">
              <FormulateInput
                type="date"
                name="dtFim"
                label="Data de Encerramento"
                validation="required"
              />
            </div>
          </div>
          <div class="row mt-3 arquivos-form">
            <FormulateInput
              type="file"
              :name="'banner'"
              label="Banner (Resolução ideal: 2000 x 240 pixels)"
              validation="required|mime:image/jpeg,image/gif,image/png,image/x-eps"
              class="col-md-4"
            />
          </div>
          <div class="row mt-3 arquivos-form">
            <div class="form-check d-flex pl-2 pb-2 align-items-center">
              <input
                type="checkbox"
                id="ciente"
                v-model="aceite"
                name="ciente"
              /><label for="ciente" class="small ml-1"
                >Aceito os
                <a
                  href="https://www.cdlbh.com.br/termo-aditivo-ao-contrato-de-filiacao-e-rateio-de-despesas-produto-clube-de-vantagens-cdl-bh/"
                  target="_blank"
                  >termos de uso e política de vendas</a
                ></label
              >
            </div>
          </div>
        </div>
        <div class="row mt-5 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
            <Botao
              title="Voltar"
              @click="$router.push({ name: 'clube-painel' })"
              nameClass="btn btn-outline-secondary btn-lg btn-block"
              >VOLTAR</Botao
            >
          </div>
          <div class="col-md-4 col-lg-2">
            <Botao
              title="Salvar"
              :class="{ disabled: loading | !aceite }"
              @click="!loading ? validar('Banner') : ''"
              nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
              :disabled="{ disabled: !aceite }"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">SALVANDO...</span>
              <span v-else>SALVAR</span>
            </Botao>
          </div>
        </div>
      </FormulateForm>
    </div>
  </div>
</template>
<script>
import Botao from "@/components/botoes/Botao";
import UploadArquivo from "@/components/cadastro/UploadArquivo";
export default {
  name: "FormEndereco",
  components: { Botao, UploadArquivo },
  props: {
    tipoProduto: {
      type: String,
      default: "",
    },
    listaAnunciosBanner: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      values: {},
      valuesImagens: {},
      usuarios: [],
      solicitarProdutos: null,
      produto: this.tipoProduto,
      envioArquivos: false,
      nUsuarios: 0,
      formulario: "cadastro",
      aceite: false,
    };
  },
  methods: {
    validar(form) {
      this.$formulate.submit(form);
    },
    maisprodutos(type) {
      this.solicitarProdutos = type;
      this.$formulate.submit("Cadastro");
    },
    salvar(tipoFormulario) {
      if (tipoFormulario === "formulario") {
        this.formulario = "imagens";
      } else {
        this.$emit("click", {
          props: {
            values: this.values,
            imagens: this.valuesImagens,
            tipoCadastro: this.produto,
            nUsuarios: this.nUsuarios,
          },
        });
      }
    },
    addUsuario() {
      var usuario = {
        name: "Usuário",
      };
      this.nUsuarios++;
      this.usuarios.push(usuario);
    },
    remover(k) {
      this.usuarios.splice(k, 1);
    },
    cancelarEnvio() {
      this.envioArquivos = false;
    },
  },
  mounted() {
    if (sessionStorage.getItem("anuncioClube")) {
      this.values = JSON.parse(sessionStorage.getItem("anuncioClube"));
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.produto-clube-vantagens-formulario /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  input {
    padding: 5px 7px;
  }
  select {
    padding: 5px 7px;
  }
  .formulate-input[data-type="radio"] {
    .formulate-input-element {
      display: flex;
      .formulate-input {
        margin-right: 7px;
        label {
          margin-left: 2px;
        }
      }
    }
  }
  .formulate-input[data-classification="textarea"] {
    textarea {
      background: white;
    }
  }
  .form-wrap {
    background: $dark-100;
    border-radius: 6px;
  }
}

.arquivos-form /deep/ {
  @import "../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
  .formulate-input-upload-area {
    .formulate-input-upload-area-mask {
      background: white;
    }
  }
  .formulate-input[data-classification="file"]
    .formulate-files
    .formulate-file {
    background: white;
  }
}

.label {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
